import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CulturalStripe from './components/CulturalStripe';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CulturalStripe />
        <Services />
        <HowItWorks />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
